<template>
  <section>
    <!-- Componentes externos -->
    <EnviarPermiso />
    <AddSolicitud />
    <VerPermiso />
    <AnularPermiso />
    <ModificarPermiso />
    <AprobarPermiso />
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon> Lista de servidores públicos
    </h3>
    <!-- Boton filtro -->
    <v-tooltip bottom>
      <v-btn
        @click.native="
          () => {
            filterShow = filterShow ? false : true;
          }
        "
        class="btn-refresh"
        slot="activator"
        ><v-icon>filter_list</v-icon>
      </v-btn>
      <span>Búsqueda/filtros</span>
    </v-tooltip>
    <!-- Boton acutualizar -->
    <v-tooltip bottom>
      <v-btn
        @click.native="cargarDatos()"
        class="btn-refresh"
        slot="activator"
        ><v-icon>refresh</v-icon>
      </v-btn>
      <span>{{ $t("common.updateList") }}</span>
    </v-tooltip>
    <!-- Filtros-->
    <v-flex xs12>
      <transition name="slide-fade">
        <div class="filter-container" v-show="filterShow">
          <v-icon small color="primary">search</v-icon>
          <div class="filter-item">
            <v-text-field
              label="Nombre"
              type="text"
              v-model="form.nombre"
              @input="filternombre"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Fecha de ingreso"
              type="date"
              v-model="form.fecha_ingreso"
              @input="filterFechaIngreso"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Fecha de pasivo"
              type="date"
              v-model="form.fecha_pasivo"
              @input="filterFechaPasivo"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Item"
              type="number"
              v-model="form.item"
              @input="filterItem"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Estado"
              type="text"
              v-model="form.activo_pasivo"
              @input="filterActivoPasivo"
            ></v-text-field>
          </div>
          <!-- botones cerrar -->
          <div class="btn-filter">
            <v-tooltip bottom>
              <v-btn icon small slot="activator" @click.native="recargar()">
                <v-icon small>refresh</v-icon>
              </v-btn>
              <span>Recargar filtros</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                icon
                slot="activator"
                @click.native="
                  () => {
                    filterShow = false;
                  }
                "
              >
                <v-icon small>close</v-icon>
              </v-btn>
              <span>Cerrar filtros</span>
            </v-tooltip>
          </div>
        </div>
      </transition>
    </v-flex>
    <v-card>
      <v-card-text>
        <v-data-table
          :items="lista_funcionarios"
          :headers="headers"
          class="elevation-1"
          :disable-initial-sort="true"
          item-key="id"
          :search="filters"
          :custom-filter="customFilter"
          :loading="loading"
          no-data-text="No se tiene registros"
          no-results-text="No se encontraron coincidencias"
          :rows-per-page-items="[25, 50, { text: 'Todos', value: -1 }]"
        >
          <!-- Template de filas y columnas  -->
          <template slot="items" slot-scope="items">
            <td class="text-xs-center">{{ items.item.nombre }}</td>
            <td class="text-xs-center">{{ items.item.fecha_ingreso }}</td>
            <td class="text-xs-center">
              {{ items.item.fecha_pasivo ? items.item.fecha_pasivo : "" }}
            </td>
            <td class="text-xs-center">{{ items.item.item }}</td>
            <td class="text-xs-center">
              <v-chip
                :color="
                  items.item.activo_pasivo.split('|')[1] == 'Activo'
                    ? 'success'
                    : 'error'
                "
                text-color="white"
                >{{
                  items.item.activo_pasivo.split("|")[1] == "Activo"
                    ? "Activo"
                    : "Pasivo"
                }}</v-chip
              >
            </td>
            <!--  value
                    :input-value="
                      items.item.id_estado_movilidad == 1 || items.item.id_estado_movilidad == 53
                        ? true
                        : false
                    "-->
            <td
                  title="Habilitacion/Deshabilitacion de movilidades"
                
                
                >
                  <v-switch
                    v-if="
                      (items.item.id_estado_movilidad == 1 ||
                        items.item.id_estado_movilidad == 53) &&
                      (items.item.id_tipo_justificacion == 7 ||
                        items.item.id_tipo_justificacion == 13 ||
                        items.item.id_tipo_justificacion == 2 ||
                        items.item.id_tipo_justificacion == 1 ||
                        items.item.id_tipo_justificacion == 11)
                    "
                   v-model="items.item.valor_switch"
                        value=true
                    background-color="#DED8FF"
                    color="rgb(80,38,217)"
                    label="Habilitado"
                  
                    @change="habilitarDeshabilitarComision(items.item, false)"
                  ></v-switch>
                  <v-switch
                    v-if="
                      items.item.id_estado_movilidad == 52 &&
                      (items.item.id_tipo_justificacion == 7 ||
                        items.item.id_tipo_justificacion == 2 ||
                        items.item.id_tipo_justificacion == 1 ||
                        items.item.id_tipo_justificacion == 13 ||
                        items.item.id_tipo_justificacion == 11)
                    "
                    value
                    background-color="#DED8FF"
                    color="colorActivo"
                    label="Deshabilitado"
                    :input-value="items.item.id_estado_movilidad == 52 ? true : false"
                    @change="habilitarDeshabilitarComision(items.item, true)"
                  ></v-switch>
                </td>
            <td class="text-xs-center">
              <v-btn
                color="success"
                title="Aprobar"
                :to="`/permisos/usuario/${items.item.id_persona}`"
              >
                Ver Permisos
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>
<script>
import AddSolicitud from "./dialogs/AddSolicitud";
import EnviarPermiso from "./dialogs/EnviarPermiso";
import VerPermiso from "./dialogs/VerPermiso";
import AnularPermiso from "./dialogs/AnularPermiso";
import ModificarPermiso from "./dialogs/ModificarPermiso";
import AprobarPermiso from "./dialogs/AprobarPermiso";

import Filtros from "./mixins/Filtros.js";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [Filtros],
  // Variables iniciales del componente
  data() {
    return {
      lista_funcionarios: [],
      // Cabecera de la tabla
      headers: [
        // { text: "Número de documento", value: "nro_doc", align: "center" },
        { text: "Nombres", value: "nombre", align: "center" },
        {
          text: "Fecha de incorporación",
          value: "fecha_ingreso",
          align: "center"
        },
        { text: "Fecha de retiro", value: "fecha_pasivo", align: "center" },
        { text: "Ítem", value: "item", align: "center" },
        { text: "Estado", value: "activo_pasivo", align: "center" },
        { text: "Habilitar/Deshabilitar", value: "activo_pasivo", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      respuestaFuncion: ["usuario", "correo", "contraseña"],
      dialog: false,
      loading: false,
      // Variables filtros
      filterShow: true,
      form: {
        activo_pasivo:'Activo'
      },
      filters: {
        nombre: "",
        fecha_ingreso: "",
        fecha_pasivo: "",
        item: "",
        activo_pasivo: "Activo"
      }
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [4,32] // ID's de roles permitidos
      if (!this.$util.permisoRol(rolesPermitidos)) {
         this.$router.push("/accion-no-permitida");
      }
    await this.cargarDatos();
    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogCreado", item => {
      this.respuestaFuncion = item.split("-");
      this.dialog = true;
    });
  },
  // Métodos y funciones del componente
  methods: {
    async cargarDatos() {
      this.loading = true;
      try {
        let rpta = await this.$service.graphql({
        query: `
							 query{
                runQuery(consulta: "select * from persona.v_lista_personal_y_movilidad vlp where vlp.id_tipo_persona in (1)  order by vlp.item desc"){
                  respuesta
                }
              }
					`,
      });
      if (rpta.runQuery.respuesta) {
         this.lista_funcionarios = rpta.runQuery.respuesta;
      }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    //habilitar o deshabilitar movilidades
        //metodo para dsar de alta o baja la movilidad:
        async habilitarDeshabilitarComision(dato, valor) {
      try {
        let mensaje;
        let id_estado;
        if (valor == true) {
          mensaje = "¿Esta seguro de habilitar la movilidad?";
          if (
            dato.id_tipo_justificacion == 1 ||
            dato.id_tipo_justificacion == 7 ||
            dato.id_tipo_justificacion == 15
          ) {
            id_estado = 1;
          }
          if (
            dato.id_tipo_justificacion == 11 ||
            dato.id_tipo_justificacion == 2
          ) {
            id_estado = 53;
          }
        } else {
          mensaje = "¿Esta seguro de deshabilitar la movilidad?";
          id_estado = 52;
        }
       
        this.$confirm(mensaje, async () => {
          await this.$service.graphql({
            query: `
								mutation edit($id: ID!,$movilidad: EditMovilidad!){
									movilidadEdit(id: $id,movilidad: $movilidad){
										id
									}
								}  
							`,
            variables: {
              movilidad: {
                id_estado: id_estado,
              },
              id: parseInt(dato.id_movilidad),
            },
          });
          //actualizamos la vista de movilidades:
          await this.cargarDatos()
        });
        await this.cargarDatos()
      } catch (error) {
        console.log(error);
      }
    },
    movilidad(item) {
      this.$bus.$emit("openDialogMovilidad", item);
    },
    editarPersona(item) {
      this.$bus.$emit("openDialogEditarPersona", item);
    },
    aprobarMovilidad(item) {
      this.$bus.$emit("openDialogAprobarMovilidad", item);
    },
    crearPersona() {
      this.$bus.$emit("openDialogCrearPersona");
    },
    close() {
      this.respuestaFuncion = [];
      this.dialog = false;
    }
  },
  // Definición de componentes importados
  components: {
    AddSolicitud,
    EnviarPermiso,
    VerPermiso,
    AnularPermiso,
    ModificarPermiso,
    AprobarPermiso
  }
};
</script>

<style lang="scss">
$filterBackground: #e1f5f0;
$filterBorder: #e5e5e5;
.filtro {
  padding: 0;
  margin: 0;
  max-width: 100%;
}

.filter-container {
  background-color: $filterBackground;
  padding: 10px 15px 20px;
  border: 1px solid $filterBorder;
  position: relative;
  .filter-item {
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
    padding: 0em 0em 0em 0em;
    margin: 0em 0em 0em 0em;
    .v-text-field {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
    }
  }
  & > .btn-filter {
    position: absolute;
    top: -8px;
    right: 0px;
  }
  & > .v-icon {
    display: inline-block;
    margin: 14px 5px 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/permiso/PermisoRRHH.vue